import React from "react";
import { Check } from "lucide-react";
import { SERVICES } from "../../lib/catalog";

export default function Services() {
    return (
        <section
            id="services"
            className="bg-[#F5F5F4] py-24 md:py-32 border-y border-stone-200"
            data-testid="services-section"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid md:grid-cols-12 gap-12 items-start">
                    <div className="md:col-span-5 md:sticky md:top-28">
                        <div className="overline mb-4">
                            04 / Hospital Planning
                        </div>
                        <h2 className="font-cabinet font-bold text-4xl md:text-5xl leading-[1.05] tracking-tight text-ink">
                            Turnkey hospital projects,
                            <br />
                            <span className="italic font-normal text-[#0C4A6E]">
                                engineered end-to-end.
                            </span>
                        </h2>
                        <p className="mt-6 text-lg text-stone-700 leading-relaxed">
                            Beyond supplying molecules and devices, we help
                            governments, trusts and private operators plan,
                            equip and commission complete hospitals — from
                            medical architecture and labs to blood banks, HIS
                            and medical gas plants.
                        </p>
                        <img
                            src="https://images.pexels.com/photos/8442276/pexels-photo-8442276.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                            alt="Hospital medical lab"
                            className="mt-10 w-full aspect-[4/3] object-cover"
                            data-testid="services-image"
                        />
                    </div>

                    <div className="md:col-span-7">
                        <div className="grid sm:grid-cols-2 gap-4">
                            {SERVICES.map((s, i) => (
                                <div
                                    key={s.slug}
                                    className="bg-white border border-stone-200 p-6 md:p-7 hover:border-[#0C4A6E] transition-colors"
                                    data-testid={`service-${s.slug}`}
                                >
                                    <div className="flex items-center gap-3 mb-4">
                                        <span className="w-8 h-8 bg-[#0C4A6E] text-white grid place-items-center font-mono text-xs">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                        <div className="h-px flex-1 bg-stone-200" />
                                    </div>
                                    <h3 className="font-cabinet font-bold text-xl text-ink leading-snug">
                                        {s.name}
                                    </h3>
                                    <p className="mt-2 text-sm text-stone-600 leading-relaxed">
                                        {s.description}
                                    </p>
                                </div>
                            ))}
                        </div>

                        <div className="mt-8 bg-[#0C4A6E] text-white p-8 md:p-10">
                            <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-sky-200 mb-4">
                                Also covered
                            </div>
                            <div className="grid sm:grid-cols-2 gap-3 text-sm">
                                {[
                                    "Housekeeping & medical waste management",
                                    "Immunisation & vaccination export programmes",
                                    "Intrauterine devices & family planning",
                                    "Disease prevention & health promotion kits",
                                ].map((x) => (
                                    <div
                                        key={x}
                                        className="flex gap-3 items-start"
                                    >
                                        <Check
                                            size={16}
                                            strokeWidth={1.8}
                                            className="text-lime-300 mt-0.5 shrink-0"
                                        />
                                        <span className="text-sky-50/95">
                                            {x}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
